export const availableList = [
  {
    'key': '',
    'value': '',
    'text': 'TODOS',
  },
  {
    'key': 'S',
    'value': 'S',
    'text': 'SI',
  },
  {
    'key': 'N',
    'value': 'N',
    'text': 'NO',
  },
];
